import API from './api.jsx'
import DB from './db.jsx'

class User {
	constructor() {
		this.user = DB.get('user') || null
		let token = DB.get('token') || null
		if(token)
			API.setToken(token)

		// // Get user from local DB
		// console.log('USER', DB.get('user'))
	}

	// Login
	login(params) {
		let that = this
		return API.request('post', 'auth/login', params).then(function(res){
			API.setToken(res.token)
			DB.set('user', res.user)
			DB.set('token', res.token)
			that.user = res.user
		})
	}

	// Logout
	logout() {
		this.user = null
		DB.clear('user')
		DB.clear('token')
	}
	
	// Get current logged in user
	current() {
		return this.user
	}

	// User CRUD
	list() {}
	get(id) {}
	create(fields) {}
	update(id, fields) {}
	delete(id) {}
}

export default new User()